<script setup lang="ts">
import {
  DialogContent,
  DialogDescription,
  DialogOverlay,
  DialogPortal,
  DialogRoot,
  DialogTitle
} from "reka-ui"
import { useFormContext } from "../composables/useFormContext"
import type { SectionInfo } from "../types"

const api = useFormContext()

const open = defineModel<boolean>("open", { default: undefined })

function jumpTo(section: SectionInfo): void {
  section.el.value?.scrollIntoView({ behavior: "smooth", block: "start" })
  open.value = false
}

function cancel(): void {
  open.value = false
}
</script>

<template>
  <DialogRoot v-model:open="open">
    <DialogPortal>
      <DialogOverlay
        class="fixed inset-0 z-40 bg-black/40 data-[state=open]:animate-overlay-in"
      />
      <DialogContent
        data-testid="form-section-sheet"
        class="fixed inset-x-0 bottom-0 z-50 bg-base-100 rounded-t-2xl shadow-xl pb-safe data-[state=open]:animate-sheet-in focus:outline-none"
      >
        <div class="w-9 h-1 bg-base-300 rounded-full mx-auto my-2" aria-hidden="true" />

        <DialogTitle class="px-5 py-3 text-base font-semibold border-b border-base-200">
          Abschnitte
        </DialogTitle>

        <DialogDescription class="sr-only">
          Wähle einen Abschnitt, um dorthin zu springen.
        </DialogDescription>

        <ul class="py-1 max-h-[60vh] overflow-y-auto">
          <li v-for="section in api.sections.value" :key="section.id">
            <button
              type="button"
              data-testid="form-section-sheet-item"
              class="flex items-center gap-3 w-full px-5 py-3.5 text-base text-left text-base-content hover:bg-base-200 focus:bg-base-200 focus:outline-none"
              @click="jumpTo(section)"
            >
              <span>{{ section.title }}</span>
              <span
                v-if="section.hasError.value"
                data-testid="form-section-sheet-error"
                class="text-error ml-auto"
                aria-label="Fehler"
              >●</span>
            </button>
          </li>
        </ul>

        <button
          type="button"
          data-testid="form-section-sheet-cancel"
          class="block w-full py-3.5 text-base text-base-content/70 border-t border-base-200 focus:outline-none focus:bg-base-200"
          @click="cancel"
        >
          Abbrechen
        </button>
      </DialogContent>
    </DialogPortal>
  </DialogRoot>
</template>
